import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);
import {routes} from "./public-routes";

export default new VueRouter({
    mode: 'hash',
    routes: routes,
});
